import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/artikel/oopbuy-spreadsheet-guide/page";
import ArticleSneaker from "../pages/artikel/oopbuy-sneaker-spreadsheet/page";
import ArticleSafety from "../pages/artikel/oopbuy-sicherheit-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/artikel/oopbuy-sneaker-spreadsheet",
    element: <ArticleSneaker />,
  },
  {
    path: "/artikel/oopbuy-sicherheit-guide",
    element: <ArticleSafety />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
